module.exports = __webpack_public_path__ + "img/selected3-min.bc559e0e.png";